const educations = [
  {
    title: 'Australian Computer Society',
    role: 'Professional Year Program',
    skills: 'Professional practice',
    period: '2018',
    location: 'Australia',
  },
  {
    title: 'Queensland University of Technology',
    role: "Bachelor's Degree in Computer Science",
    skills: 'Software Development, Web Development',
    period: '2016–2017',
    location: 'Brisbane, Australia',
  },
  {
    title: 'TAFE Queensland',
    role: 'Diploma in Software Development',
    skills: 'Web Development, Databases, Project Management',
    period: '2015',
    location: 'Queensland, Australia',
  },
];

export default educations;
